import React from 'react';
import ProductCard from './ProductCard';
import { popularProducts } from '../data';

export default function PopularProducts() {
  return (
    <section style={{ margin: '3rem 0' }}>
      <div className="container">
        <h2 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#111827', marginBottom: '1.5rem' }}>Popular Products</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
          {popularProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
}
